import "./Checkbox.scss";

import React, { useCallback, useMemo } from "react";
import clsx from "clsx";
import BaseCheckbox from "@mui/material/Checkbox";

import * as Utils from "../../../lib/util/Utils";

import { IconLine, IconTick } from "../../../assets";

export interface CheckboxProps {
	id?: string;
	value?: string | boolean;
	checked?: boolean;
	indeterminate?: boolean;
	defaultValue?: boolean;
	className?: string;
	disabled?: boolean;
	onChange?: (
		event: React.ChangeEvent<HTMLInputElement>,
		checked: boolean,
		id?: string,
	) => void;
	size?: "small" | "medium";
}

const Checkbox = (props: CheckboxProps) => {
	const {
		id,
		value,
		checked,
		size,
		onChange,
		disabled,
		className,
		defaultValue,
		indeterminate,
	} = props;

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
			if (onChange) {
				onChange(event, checked, id);
			}
		},
		[id, onChange],
	);

	const isChecked = useMemo(() => {
		if (checked !== undefined) {
			return checked;
		}

		return Boolean(value);
	}, [value, checked]);

	return (
		<BaseCheckbox
			disabled={disabled}
			onClick={Utils.stopPropagation}
			size={size}
			disableRipple={true}
			icon={<IconTick />}
			checkedIcon={<IconTick />}
			indeterminateIcon={<IconLine />}
			indeterminate={indeterminate}
			className={clsx("Checkbox", className)}
			classes={{
				checked: "--checked",
				indeterminate: "--indeterminate",
				disabled: "--disabled",
			}}
			onChange={handleChange}
			value={value}
			checked={isChecked}
			tabIndex={0}
		/>
	);
};

export default Checkbox;
